import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import persianJs from "persianjs";
import { FaRegPauseCircle, FaRegPlayCircle } from "react-icons/fa";
import { IoMdVolumeHigh, IoMdVolumeOff } from "react-icons/io";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlinePauseCircleFilled,
  MdOutlinePlayCircleFilled,
} from "react-icons/md";
import {
  AudioController,
  DropDownContainer,
  Mute,
  OptionContainer,
  PlayButton,
  Range,
  TimerContainer,
  WaveDiv,
  WaveSurferWrap,
} from "./index.styled";
import { convertHMS } from "utils/time";
const Wave = ({ audio, speaker = false, display, timeCallback }) => {
  const containerRef = useRef();
  const waveSurferRef = useRef({
    isPlaying: () => false,
  });
  const [isPlaying, setIsPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const waveSurfer = WaveSurfer.create({
      container: containerRef.current,
      backend: "WebAudio",
      barWidth: 1,
      barGap: 2,
      barRadius: 2,
      cursorWidth: 1,
      height: 60,
      progressColor: "#629EE8",
      responsive: true,
      waveColor: "#D1E6FF",
      cursorColor: "transparent",
    });
    waveSurfer.load(audio);

    waveSurfer.on("ready", () => {
      waveSurferRef.current = waveSurfer;
      waveSurfer.setPlaybackRate();
      waveSurfer.setVolume(0.5);
      setTime(waveSurfer.getDuration());
    });

    waveSurfer.on("play", () => {
      // why 2 interval at the same time ?

      if (timeCallback) {
        setInterval(() => {
          timeCallback(waveSurfer?.getCurrentTime?.());
        }, 30);
      }
      const currentsec = setInterval(() => {
        if (waveSurfer?.getCurrentTime) {
          setCurrentTime(waveSurfer?.getCurrentTime?.());
        }
      }, 1000);

      // what is this return ??? Is it doing anything ?? is it Not for useEffect !!!??? misplaced here ??
      return () => {
        clearInterval(currentsec);
      };
    });

    waveSurfer.on("finish", () => {
      setIsPlaying(false);
      // what is this return ??? Is it doing anything ?? is it Not for useEffect !!!??? misplaced here ??
      return () => {
        waveSurfer.destroy();
      };
    });

    return () => {
      waveSurfer.destroy();
    };
  }, [audio]);

  const [mute, setMuteState] = useState(false);
  function handleMute(e) {
    e.stopPropagation();
    setMuteState(!mute);
    waveSurferRef.current.setMute(!mute);
  }

  const [volume, setVolume] = useState(5);

  function handleVolume(e) {
    e.stopPropagation();
    const v = Number(e.target.value) / 10;
    if (v === 0) {
      setMuteState(true);
      waveSurferRef.current.setMute(true);
    } else {
      setMuteState(false);
      waveSurferRef.current.setMute(false);
      setVolume(v);
      waveSurferRef.current.setVolume(v);
    }
  }

  function handleSpeed(e) {
    e.stopPropagation();
    const s = Number(e.target.value);
    setSpeed(e.target.value);
    setShow(!show);
    waveSurferRef.current.setPlaybackRate(s);
  }

  const [show, setShow] = useState(false);
  const [speed, setSpeed] = useState(1);

  const selectHandler = () => {
    setShow(!show);
  };
  return (
    <WaveSurferWrap>
      <div className="topContainer">
        <PlayButton
          className="button"
          onClick={(e) => {
            e.stopPropagation();
            waveSurferRef.current.playPause();
            setIsPlaying(waveSurferRef.current.isPlaying());
          }}
        >
          {/* {isPlaying ? (speaker ? <ImPause/>  : <img src={PauseIcon} alt=""/>) : (speaker ? <BiPlayCircle/> : <img src={PlayIcon} alt="play icon"/>)
        } */}

          {isPlaying ? (
            speaker ? (
              <FaRegPauseCircle />
            ) : (
              <MdOutlinePauseCircleFilled />
            )
          ) : speaker ? (
            <FaRegPlayCircle />
          ) : (
            <MdOutlinePlayCircleFilled />
          )}
        </PlayButton>

        <WaveDiv ref={containerRef} className={display && "active"} />
      </div>
      <div className="controller">
        <TimerContainer>
          {persianJs(convertHMS(currentTime.toFixed()))
            .englishNumber()
            .toString() + "/"}
          <span>
            {persianJs(convertHMS(time.toFixed())).englishNumber().toString() +
              " "}
          </span>
        </TimerContainer>
        <AudioController>
          {/* <SelectSpeed onChange={handleSpeed}>
              <option value="0.5">X 0.5</option>
              <option value="1" selected >X 1</option>
              <option value="1.5">X 1.5</option>
              <option value="2">X 2</option>
            </SelectSpeed> */}
          <DropDownContainer onClick={selectHandler} className="speed">
            <div>
              <MdOutlineKeyboardArrowDown className={show ? "open" : ""} />
              <span>x {speed}</span>
            </div>

            <OptionContainer
              onClick={handleSpeed}
              className={!show ? "show" : ""}
            >
              <option value="0.5">X 0.5</option>
              <option value="1" selected>
                X 1
              </option>
              <option value="1.5">X 1.5</option>
              <option value="2">X 2</option>
            </OptionContainer>
          </DropDownContainer>
          <Mute onClick={handleMute}>
            {mute ? <IoMdVolumeOff /> : <IoMdVolumeHigh />}
          </Mute>
          <Range>
            <input
              type="range"
              min="0"
              max="10"
              defaultValue={volume}
              onChange={handleVolume}
            />
          </Range>
        </AudioController>
      </div>
    </WaveSurferWrap>
  );
};

export default Wave;
